import { api } from "@app/api";
import { PaginatedData, Support } from "@app/types/interfaces";

const activeSupportPath = "/records/suport";

export const getActiveSupportList = (): Promise<PaginatedData<Support>> => {
  const queryParams = {
    datafy_fields: "email,phone,activ",
    active__eq: true,
    pageSize: 1,
  };
  return api.get(activeSupportPath, { params: queryParams });
};
